import React from 'react'
import Link from 'gatsby-link'
import Particles from "./particles";
import Container from "./container";

const HeroSmall = ({ title, desc, name }) => (
  <div className="hero-area-small">
    <Particles />
    <Container customClassName="hero-area-container">
      <p className="static-project-name">{name}</p>
      <h1>{title}</h1>
      <p>{desc}</p>
    </Container>
  </div>
)

export default HeroSmall;



// WEBPACK FOOTER //
// ./src/components/hero-small-project.js